import { render, staticRenderFns } from "./referral-info-link.vue?vue&type=template&id=ffe4f18e&scoped=true"
import script from "./referral-info-link.vue?vue&type=script&lang=js"
export * from "./referral-info-link.vue?vue&type=script&lang=js"
import style0 from "./referral-info-link.vue?vue&type=style&index=0&id=ffe4f18e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffe4f18e",
  null
  
)

export default component.exports